import Vue from 'vue';
import moment from 'moment';

Vue.filter('date', (value) => {
  if (value) {
    if (typeof(value) === 'string' && value.indexOf('/') > -1) {
      return moment(value, 'YYYY/MM/DD', true).format('L');
    } else {
      return moment(value).format('L')
    }
  }
});

Vue.filter('datetime', (value) => {
  return moment(value).format('lll')
});

Vue.filter('time', (value) => {
  if (value) {
    let d = new moment(value, 'HH:mm:ss');
    return d.format('hh:mm A')
  } else {
    return '';
  }
});
